import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from '../api.service';

@Component({
	selector: 'move-unit',
	templateUrl: './move-unit.component.html',
	styleUrls: ['./move-unit.component.scss']
})

export class MoveUnitComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	@Input() courseId = 0
	// @Input() courseName = ''
	@Input() unitId = 0
	@Input() unitName = ''
	@Input() destinationCategoryId = -1
	destinationCourseId = -1
	// @Input() destinationCourseName = ''

	categories: any[] = []
	categoryCourses: any[] = []

	movingUnit = false
	moveUnitSuccess = false
	moveUnitError = false

	getCategoriesSub = new Subscription
	getCategoryCoursesSub = new Subscription
	moveUnitSub = new Subscription

	@Output() onClose: EventEmitter<boolean> = new EventEmitter

	constructor(private dataService: ApiService) {}

	ngOnInit() {
		this.getCategories()
		if (this.destinationCategoryId > 0) this.getCategoryCourses(this.destinationCategoryId)
	}

	ngAfterViewInit() {}
	
	ngOnChanges() {}
	
	ngOnDestroy() {
		this.getCategoriesSub?.unsubscribe()
		this.getCategoryCoursesSub?.unsubscribe()
	}

	close() {
		this.onClose.emit(true)
	}

	getCategories() {
		this.getCategoriesSub = this.dataService.getCategories()
		.subscribe(
			data => {
				// console.log(data)
				this.categories = data
			},
			error => {
				console.log(error)
			},
		)
	}

	getCategoryCourses(category: number) {
		// console.log(category)
		this.getCategoryCoursesSub = this.dataService.getCategoryCourses(category)
		.subscribe(
			data => {
				// console.log(data)
				this.categoryCourses = data
			},
			error => {
				console.log(error)
			},
		)
	}

	moveUnit() {
		this.movingUnit = true
		this.moveUnitSuccess = false
		this.moveUnitError = false

		this.moveUnitSub = this.dataService.moveUnit(this.unitId, this.destinationCourseId)
		.subscribe(
			data => {
				console.log(data)

				let status = data.status
				if (status == "Ok") {
					this.movingUnit = false
					this.moveUnitSuccess = true
					this.moveUnitError = false
				} else {
					this.movingUnit = false
					this.moveUnitSuccess = false
					this.moveUnitError = true	
				}

			},
			error => {
				console.log(error)

				this.movingUnit = false
				this.moveUnitSuccess = false
				this.moveUnitError = true
			},
		)
	}

}
